<ngx-spinner type="line-scale">
    <div class="loader"></div>
</ngx-spinner>

<main>
    <router-outlet></router-outlet>
</main>

@if (showPostLoginUi) {
    <!-- Notification Display Component -->
    <!-- <app-general-reminder-drawer></app-general-reminder-drawer> -->
    <app-notification-display></app-notification-display>
    <tour-step-template>
        <ng-template let-step="step">
            <div [style.width]="step.stepDimensions?.width" [style.min-width]="step.stepDimensions?.minWidth" [style.max-width]="step.stepDimensions?.maxWidth" class="main-container">
                <div class="title-container">
                    <div class="title">{{ step?.title }}</div>

                    <div class="d-flex gap-2">
                        <p-button label="Skip" ariaLabel="Skip" variant="text" [rounded]="true" variant="outlined" (click)="appTourService.skipTour()" />

                        <p-button label="Exit" ariaLabel="Exit" variant="text" [rounded]="true" variant="outlined" (click)="appTourService.exitTour()" />
                    </div>
                </div>

                <p class="card-text" [innerHTML]="step.content"></p>

                <div class="buttons" [class.no-progress]="!step.showProgress">
                    <p-button [disabled]="!tourService.hasPrev(step)" icon="pi pi-angle-left" iconPos="left" severity="secondary" [rounded]="true" [label]="step.prevBtnTitle" (click)="tourService.prev()" />
                    @if (step.showProgress) {
                        <div class="progress">
                            {{ tourService.steps.indexOf(step) + 1 }} /
                            {{ tourService.steps.length }}
                        </div>
                    }
                    @if (tourService.hasNext(step) && !step.nextOnAnchorClick) {
                        <p-button icon="pi pi-angle-right" iconPos="right" [rounded]="true" [label]="step.nextBtnTitle" (click)="tourService.next()" />
                    }
                    @if (!tourService.hasNext(step)) {
                        <p-button [label]="step.endBtnTitle" (click)="tourService.end()" />
                    }
                </div>
            </div>
        </ng-template>
    </tour-step-template>
}
